module.exports = __webpack_public_path__ + "img/projectNews.a9332c2f.svg";